import {
  useTelemedicineForPediatricsActivationStatus,
  GET_TELEMEDICINE_FOR_PEDIATRICS_ELIGIBILITY_QUERY_KEY,
  TelemedicineForPediatricsEligibility
} from "#/components/telemedicine/pediatrics/hooks/useTelemedicineForPediatricsActivation"
import { useQueryClient } from "@tanstack/react-query"

function useCreateTelemedicineForPediatricsEligibilityOverride(): (data: TelemedicineForPediatricsEligibility) => void {
  const queryClient = useQueryClient()
  return (data: TelemedicineForPediatricsEligibility) => {
    queryClient.setQueryDefaults(GET_TELEMEDICINE_FOR_PEDIATRICS_ELIGIBILITY_QUERY_KEY, {
      staleTime: Infinity,
      cacheTime: Infinity
    })
    queryClient.setQueryData(GET_TELEMEDICINE_FOR_PEDIATRICS_ELIGIBILITY_QUERY_KEY, data)
  }
}

export function useTelemedicineForPediatricsMapper() {
  const availability = useTelemedicineForPediatricsActivationStatus()
  const override = useCreateTelemedicineForPediatricsEligibilityOverride()
  const isActivated = availability?.activationStatus === "activated"

  return {
    blueberry_activated: {
      value: isActivated,
      toggle: () => {
        if (isActivated) {
          override({
            eligibilityRecordId: null,
            registrationCompleted: false,
            enrollmentUrl: ""
          })
        } else {
          override({
            eligibilityRecordId: "1",
            registrationCompleted: true,
            enrollmentUrl: "www.testurl.com"
          })
        }
      }
    }
  }
}
